import React, { useEffect } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useForm } from 'react-hook-form';

import { jobInfoService } from 'services/auth';
import { getAccessToken } from 'utils/authentication';
import { getErrorText } from 'utils/geterrortext';
import SelectInput from '@core/components/selectInput/SelectInput';
import SelectInputRadioButton from '@core/components/selectinputradiobutton/SelectInputRadioButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './JobForm.module.scss';

const JobInfoForm = ({ onBack, closeHandler, refetchHandler, toast, type = 'account' }) => {
    const { data } = useQuery(
        ['job-info', getAccessToken()],
        () => jobInfoService.GET()
    );
    const { mutate } = useMutation(jobInfoService.PUT, {
        onSuccess: () => {
            refetchHandler();
            if (type === 'account') {
                closeHandler();
            }
        },
        onError: (err) => {
            toast(getErrorText(err), 'alert');
        }
    });

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        defaultValues: {}
    });

    useEffect(() => {
        if (data?.data) {
            reset({
                job_role: data.data.job_role,
                years_of_experience: data.data.years_of_experience,
            });
        }
    }, [data, reset]);

    const submitForm = (payload) => {
        mutate(payload);
    };

    return (
        <div className={classes.wrapper}>
            <h3>Tell Us About You</h3>
            <form onSubmit={handleSubmit(submitForm)} className="d-flex flex-column gap-3">

                <SelectInput
                    input={{
                        name: 'job_role',
                        id: 'job_role',
                        label: 'What is your Job Role?'
                    }}
                    validation={{ required: true }}
                    errors={errors}
                    control={control}
                    options={data?.data?.metadata?.job_roles || []}
                    optionsType='array'
                    placeholder="Job Role"
                />
                <div className='mt-2'></div>
                <div className={classes['describe-wrapper']}>
                    <SelectInputRadioButton
                        validation={{ required: true }}
                        input={{
                            label: 'Years of experience in pharma',
                            name: 'years_of_experience',
                            id: 'years_of_experience'
                        }}
                        errors={errors}
                        control={control}
                        options={data?.data?.metadata?.years_of_experiences || []}
                        optionsIdKey='value'
                        optionsNameKey='label'
                        horizontal={false}
                    />
                </div>
                <div className='d-flex justify-content-center gap-5 px-md-5 px-0 mt-4'>
                    <ActionButton kind='blank' onClick={onBack}>
                        Back
                    </ActionButton>
                    <ActionButton type="submit">
                        {type === 'account' ? 'Save' : 'Next'}
                    </ActionButton>
                </div>
            </form>
        </div>
    );
};

export default JobInfoForm;
